import React, { useEffect, useState } from 'react';

const Toast = ({ message, type = 'error', onClose, duration = 5000 }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    if (onClose) onClose();
                }, 300); // Wait for fade out animation
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            if (onClose) onClose();
        }, 300);
    };

    if (!message) return null;

    const bgColor = type === 'error' ? 'bg-red-50' : type === 'success' ? 'bg-green-50' : 'bg-neutral-50';
    const borderColor = type === 'error' ? 'border-red-200' : type === 'success' ? 'border-green-200' : 'border-neutral-200';
    const textColor = type === 'error' ? 'text-red-900' : type === 'success' ? 'text-green-900' : 'text-neutral-900';

    return (
        <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
            }`}
            style={{ maxWidth: '90%', width: 'auto', minWidth: '300px' }}
        >
            <div className={`${bgColor} ${borderColor} hairline p-4 flex items-center justify-between gap-4 shadow-lg`}>
                <div className={`flex-1 ${textColor} font-mono text-sm`}>
                    {message}
                </div>
                <button
                    onClick={handleClose}
                    className={`${textColor} hover:opacity-60 transition-opacity font-mono text-lg border-none bg-transparent p-0 m-0 flex-shrink-0`}
                    aria-label="Close"
                >
                    ✕
                </button>
            </div>
        </div>
    );
};

export default Toast;


